import { Injectable } from '@angular/core';
import { DbService } from '../db/db.service';
import { getFileNameExtension, isNullOrUndefined } from '@pineapplelab/util';
import { Project } from '@app/models/firebase/project';
import { Postulation } from '@app/models/firebase/postulation';
import { StorageService } from '../storage/storage.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { JobOffer } from '@app/models/job-offer/jobOffer';

@Injectable({
  providedIn: 'root'
})
export class PostulationService {

  constructor(
    private db: DbService,
    private storageService: StorageService,
  ) { }

  async save(model: Postulation, projectId: string) {
    if (isNullOrUndefined(model.id)) {
      model.id = this.db.createId();
    }
    const commonPath = `${Project.PATH}/${projectId}/${Postulation.PATH}/${model.id}`;
    if (!isNullOrUndefined( model.__fileImage )) {
       model.image = await this.storageService.saveOrRemoveImagesIfNecessary( model.__fileImage, commonPath )
    }
    if (!isNullOrUndefined( model.__dniFront )) {
       model.dniFront = await this.storageService.saveOrRemoveImagesIfNecessary( model.__dniFront, commonPath )
    }
    if (!isNullOrUndefined( model.__dniBack )) {
       model.dniBack = await this.storageService.saveOrRemoveImagesIfNecessary( model.__dniBack, commonPath )
    }
    const json = model.toJson();
    await this.db.firestore
      .collection(Project.PATH)
      .doc(projectId)
      .collection(JobOffer.PATH)
      .doc(model.jobOfferId)
      .collection(Postulation.PATH)
      .doc(model.id).set(json, { merge: true });
    return json;
  }

  async saveOrRemoveDocument(model: Postulation, projectId: string) {
    const commonPath = `${Project.PATH}/${projectId}/${Postulation.PATH}/{${model.id}}`;
    if (!isNullOrUndefined( model.__fileCV )) {
      const path = `${commonPath}/postulations.${getFileNameExtension( model.__fileCV.name )}`;
      model.__fileExtension = this.getImageExtension(path)
      model.cv = await this.storageService.uploadFile( path, model.__fileCV, {contentType: 'application/pdf'}  );
    } else if (model.__fileCV === null) {
      model.cv = null;
    }
  }

  getImageExtension(path: string){
    let delimiter = "/postulations.";
    let index = path.indexOf(delimiter);
    return path.substring(index + delimiter.length);
  }

  async remove(projectId: string, model: Postulation) {
    const commonPath = `${Project.PATH}/${projectId}/${Postulation.PATH}/${model.id}`;
    //  TODO: FIX IMAGE DELETION FROM STORAGE
    // const path = `${commonPath}/postulations.${model.__fileExtension}`;
    // await this.fireStorage.storage.ref(path).delete()
    return await this.db.firestore.collection(Project.PATH).doc(projectId).collection(JobOffer.PATH).doc(model.jobOfferId).collection(Postulation.PATH).doc(model.id).update({ is_deleted: true });
  }

  async getPostulation(projectId: string, postulationId: string, jobOfferId: string) {
    const doc = await this.db.firestore.collection(Project.PATH).doc(projectId).collection(JobOffer.PATH).doc(jobOfferId).collection(Postulation.PATH)
    .doc(postulationId).get();

    if (doc.exists) {
      return new Postulation(doc.data());
    }
    return null;
  }

  async resetAllPostulationsJobProcess(projectId: string, jobOfferId: string) {
    const snapshot = await this.db.firestore.collection(Project.PATH).doc(projectId).collection(JobOffer.PATH).doc(jobOfferId).collection(Postulation.PATH).get();
    const promises = snapshot.docs.map(async (doc) => {
      await doc.ref.update({ step_id: null, step_name: null});
    });
    await Promise.all(promises);
  }
}
